import {
  computed, reactive, ref, ssrRef, unref, useRouter,
} from '@nuxtjs/composition-api';

import IBiuroBaseInfo from '~/components/biura/types/IBiuroBaseInfo';
import TClusterRef from '~/components/map/types/clusterRef';
import IMapBiuraServiceConfig from '~/components/map/types/IMapBiuraServiceConfig';
import TMapRef from '~/components/map/types/mapRef';
import IGoogleMapState from '~/components/map/types/mapState';
import IMarkersInnerState from '~/components/map/types/markersInnerState';

import buildConfig from '../config/buildConfig';
import buildReusableMarkerSvg from '../marker/buildReusableMarkerSvg';
import getActiveMarker from '../marker/getActiveMarker';
import getInactiveMarkers from '../marker/getInactiveMarkers';

interface IBuildServiceConfigParam {
  cluster: TClusterRef;
  mapRef: TMapRef;
  isMobile: boolean;
}
const buildServiceConfig = (params: IBuildServiceConfigParam): IMapBiuraServiceConfig => {
  const { mapRef, cluster, isMobile } = params;

  const markersInnerState = reactive<IMarkersInnerState<IBiuroBaseInfo>>({
    markers: ssrRef(undefined),
    activeMarker: ref(unref(undefined)),
  });
  const mapState = reactive<IGoogleMapState<IBiuroBaseInfo, IBiuroBaseInfo>>({
    isMapToBeRendered: ref(false),
    activeMarkerExtended: ref(undefined),
    activeMarker: computed(() => getActiveMarker(markersInnerState) as IBiuroBaseInfo | undefined),
    inactiveMarkers: computed(() => getInactiveMarkers(markersInnerState) as IBiuroBaseInfo[] | undefined),
    markers: computed(() => markersInnerState.markers as IBiuroBaseInfo[] | undefined),
  });
  const result: IMapBiuraServiceConfig = {
    mapState,
    markersInnerState,
    config: buildConfig(isMobile),
    mapRef,
    cluster,
    router: useRouter(),
    markerIcon: buildReusableMarkerSvg(),
  };

  return result;
};
export default buildServiceConfig;
